<template>
  <div class="page-wrapper">
    <div class="page-wrapper-container">
      <div class="page-wrapper-header">
        <WidgetToolbar title="Notification" :icon="require('@/assets/icons/notification-active.svg')">
          <div class="options">
            <widgetSearch class="search-account" placeholder="Search here..." icon="right" v-model="filter_form.query"
              @keyup="searchNotification">
            </widgetSearch>
            <div class="h-spacer"></div>
            <widgetDropdown class="dropdown-filter" v-model="show_filter" :right="true" :hover="false"
              :interactive="true">
              <button class="btn-filter dropdown-toggle">
                {{ filter_form.type }}
                <img src="@/assets/icons/arrow_down_green.svg" />
              </button>
              <div slot="dropdown" class="dropdown-widget right">
                <a @click.prevent="filterNotificationType('All')" class="dropdown-item" href="#">All</a>
                <a @click.prevent="filterNotificationType('Unread')" class="dropdown-item" href="#">Unread</a>
              </div>
            </widgetDropdown>

            <widgetButton @click="markAllAsRead()" :loading="mark_all_as_read_loading" class="btn-transparent-secondary">
              Mark all as read
            </widgetButton>
          </div>
        </WidgetToolbar>
      </div>
      <div class="page-wrapper-body">
        <div class="left-panel">
          <div class="profile-widget">
            <widgetProfile :title="user.names" :size="90" :text_size="34" :showContent="false" :file_name="user.profile"
              :path="$fullUrl('images/profiles/')" @click="
                $router.push({
                  path: '/profile/consultant',
                })
                "></widgetProfile>
            <h2 class="profile-name">{{ user.names | validate }}</h2>
            <span class="profile-location" v-if="!isCustomer">{{
              user.location | validate
            }}</span>
          </div>
        </div>
        <div class="right-panel">
          <div class="notification-widget-body" v-if="!loading_notifications && notifications.length > 0">
            <div class="notification-item" v-for="(not, i) in notifications" :key="i">
              <div class="profile-widget" v-if="not.type === 'company-add-member' ||
                not.type === 'invite-manager' ||
                not.type === 'request-merge'
                ">
                <widgetProfile v-if="not.issuer && not.issuer.company_profile"
                  :title="not.issuer && not.issuer.company_profile ? not.issuer.company_profile.name : ''" :size="35"
                  :showContent="false"
                  :file_name="not.issuer && not.issuer.company_profile ? not.issuer.company_profile.logo : ''"
                  :path="$fullUrl('images/profiles/')"></widgetProfile>
              </div>
              <div class="profile-widget" v-else>
                <widgetProfile v-if="not.issuer" :title="not.issuer
                  ? not.issuer.first_name + ' ' + not.issuer.last_name
                  : ''
                  " :size="35" :showContent="false" :file_name="not.issuer ? not.issuer.profile_picture : ''"
                  :path="$fullUrl('images/profiles/')"></widgetProfile>
              </div>

              <!-- Notification content -->
              <div class="notification-contents">
                <!-- titles -->
                <h2 v-if="not.type === 'project'">
                  Invitation to be a project Member
                </h2>
                <h2 v-else-if="not.type === 'employment'">
                  Employment invitation
                </h2>
                <h2 v-else-if="not.type === 'message'">Message</h2>
                <h2 v-else-if="not.type === 'profile-view'">
                  Profile View Request
                </h2>
                <h2 v-else-if="not.type === 'profile-grant'">
                  Profile View permission granted
                </h2>
                <h2 v-else-if="not.type === 'confirm-employment-verification'">
                  Employment verification
                </h2>

                <h2 v-else-if="not.type === 'invite-manager'">
                  Manager Invitation
                </h2>
                <h2 v-else-if="not.type === 'request-merge'">
                  Request to merge
                </h2>
                <h2 v-else-if="not.type === 'company_matching'">
                  Company Matching
                </h2>
                <h2 v-else-if="not.type === 'confirm-project-verification'">
                  Project verification
                </h2>

                <h2 v-else-if="not.type === 'company-add-member'">
                  Profile management request
                </h2>

                <h2 v-else-if="not.type === 'company-add-member-accepted'">
                  Profile management
                </h2>

                <h2 v-else-if="not.type === 'company-add-member-rejected'">
                  Profile management
                </h2>

                <h2 v-else-if="not.type === 'accept-assignment'">
                  Assignment invitation
                </h2>

                <h2 v-else-if="not.type === 'assignment-accepted'">
                  Assignment accepted
                </h2>

                <h2 v-else-if="not.type === 'assignment-not-accepted'">
                  Assignment not accepted
                </h2>

                <h2 v-else-if="not.type === 'company-pitching'">
                  Company pitching
                </h2>

                <h2 v-else-if="not.type === 'accept-pitch'">Pitch accepted</h2>
                <h2 v-else-if="not.type === 'decline-pitch'">Pitch declined</h2>

                <h2 v-else-if="not.type === 'student_instructor_remainder'">
                  Reminder
                </h2>
                <h2 v-else-if="not.type === 'internship_assign'">
                  Assignment Suggestions
                </h2>

                <h2 v-else-if="not.type === 'student_survey'">Survey</h2>

                <h2 v-else-if="not.type === 'student_evaluation'">
                  Evaluation
                </h2>

                <h2 v-else-if="not.type === 'student_profile_completion'">
                  Profile Completion
                </h2>

                <h2 v-else-if="not.type === 'applied_students'">
                  Assignment applicants
                </h2>

                <h2 v-else-if="not.type === 'student_internship_confimed'">
                  Assignment
                </h2>

                <h2 v-else-if="not.type === 'company_contract_student'">
                  Assignment contract
                </h2>

                <h2 v-else-if="not.type === 'student-rate-notification'">
                  Company Rating
                </h2>

                <h2 v-else-if="not.type === 'student-update-profile-notification'">
                  Update profile
                </h2>

                <h2 v-else-if="not.type === 'instuctor-uploaded-cv'">
                  CV upload
                </h2>

                <h2 v-else-if="not.type === 'instuctor-aproved-profile'">
                  Profile aproved
                </h2>
                <h2 v-else-if="not.type === 'questionnere_remainder'">
                  Profile aproved
                </h2>

                <h2 v-else-if="not.type === 'school_connent_account'">
                  Meritos account
                </h2>

                <h2 v-else-if="not.type === 'communication-notification'">
                  {{ not.title | validate }}
                </h2>

                <h2 v-else>Project verification</h2>

                <!-- content -->

                <p v-if="not.type === 'company-add-member'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>
                <p v-else-if="not.type === 'accept-pitch'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>

                <p v-else-if="not.type === 'communication-notification'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>


                <p v-else-if="not.type === 'school_connent_account'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>

                <p v-else-if="not.type === 'instuctor-aproved-profile'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>

                <p v-else-if="not.type === 'questionnere_remainder'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>

                <p v-else-if="not.type === 'instuctor-uploaded-cv'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>

                <p v-else-if="not.type === 'student_instructor_remainder'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>

                <p v-else-if="not.type === 'internship_assign'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>

                <p v-else-if="not.type === 'student_survey'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>
                <p v-else-if="not.type === 'student_evaluation'">
                  <span style="margin-right: 4px" v-html="not.description"></span>
                </p>

                <p v-else-if="not.type === 'invite-manager'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'student_profile_completion'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'applied_students'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'company_matching'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'student_internship_confimed'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'student-update-profile-notification'">
                  {{ not.description | validate }}
                </p>

                <div v-else-if="not.type === 'student-rate-notification'" class="rating-nitification">
                  <p>
                    {{ not.description | validate }}
                  </p>
                  <div v-if="not.extra == 'completed'" class="rating-status">
                    Submitted
                  </div>
                  <div v-else class="rating-form">
                    <div class="rating-input-widget">
                      <star-rating inactive-color="#C1C1C1" :read-only="false" active-color="#1BA5A4" :star-size="25"
                        :show-rating="false" v-model="company_rating_form.rate"></star-rating>
                    </div>
                    <widgetButton :loading="not.loading" @click="rateCompany(not)" class="btn-primary">
                      Submit
                    </widgetButton>
                  </div>
                </div>

                <p v-else-if="not.type === 'company_contract_student'">
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'company-add-member-accepted'">
                  <span class="__colored">{{
                    (not.issuer.first_name + " " + not.issuer.last_name + " ")
                    | validate
                  }}</span>
                  is now company member
                </p>

                <p v-else-if="not.type === 'company-add-member-rejected'">
                  <span class="__colored">{{
                    (not.issuer.first_name + " " + not.issuer.last_name + " ")
                    | validate
                  }}</span>
                  is denied to be company member
                </p>

                <p v-else-if="not.type === 'request-merge'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>

                <p v-else-if="not.type === 'decline-pitch'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>
                <p v-else-if="not.type === 'company-pitching'">
                  <span style="margin-right: 4px">{{
                    not.description | validate
                  }}</span>
                </p>

                <p v-else-if="not.type === 'assignment-accepted'">
                  <span class="__colored">{{
                    (not.issuer.first_name + " " + not.issuer.last_name + " ")
                    | validate
                  }}</span>
                  {{ not.description | validate }}
                </p>
                <p v-else-if="not.type === 'assignment-not-accepted'">
                  <span class="__colored">{{
                    (not.issuer.first_name + " " + not.issuer.last_name + " ")
                    | validate
                  }}</span>
                  {{ not.description | validate }}
                </p>

                <p v-else-if="not.type === 'accept-assignment'">
                  {{ not.description | validate }}
                </p>
                <p v-else-if="not.type === 'project'">
                  <router-link :to="{
                    name: 'profile-view',
                    params: { id: not.issuer.id },
                  }">
                    <span class="__colored">{{
                      (not.issuer.first_name + " " + not.issuer.last_name + " ")
                      | validate
                    }}</span>
                  </router-link>
                  <span style="margin-right: 4px">Invited you to a project that you participated on, click
                    to</span>
                  <span class="clickable" @click="viewNotification(not.id)">view more</span>
                  details
                </p>

                <p v-if="not.type === 'employment'">
                  <router-link :to="{
                    name: 'profile-view',
                    params: { id: not.issuer.id },
                  }">
                    <span class="__colored">{{
                      (not.issuer.first_name + " " + not.issuer.last_name + " ")
                      | validate
                    }}</span>
                  </router-link>
                  <span style="margin-right: 4px">Invited you to participate on employment, click to</span>
                  <span class="clickable" @click="viewNotification(not.id)">view more</span>
                  details
                </p>

                <p v-if="not.type === 'profile-view'">
                  <router-link to="/">
                    <span v-if="not.issuer" class="__colored">{{
                      (not.issuer.first_name + " " + not.issuer.last_name + " ")
                      | validate
                    }}</span> </router-link>requested to view your full Profile and access to your Full
                  CV
                </p>
                <p v-if="not.type === 'profile-grant'">
                  <router-link v-if="not.issuer" :to="{
                    name: 'user-view-profile',
                    params: { id: not.issuer.id },
                  }">
                    <span class="__colored">{{
                      (not.issuer.first_name + " " + not.issuer.last_name + " ")
                      | validate
                    }}</span> </router-link>granted you permission to view his full Profile and access to
                  his Full CV
                </p>
                <p v-if="not.type === 'confirm-project-verification'">
                  Your Project has been verified
                </p>
                <p v-if="not.type === 'confirm-employment-verification'">
                  Your Employment has been verified
                </p>

                <!-- Notification options options -->
                <div class="options" v-if="not.type === 'profile-grant'">
                  <button v-if="not.issuer" class="ok" @click="() => {
                    $router.push({
                      name: 'user-view-profile',
                      params: { id: not.issuer.id },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'instuctor-aproved-profile'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'communication-notification'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>



                <div class="options" v-else-if="not.type === 'questionnere_remainder'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company_matching'">
                  <button class="ok" @click="showMatchingForm(not)">
                    Select
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Later
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'school_connent_account'">
                  <button class="ok" @click="approveToConnectAccountWithSchool(not)">
                    Approve
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Reject
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'instuctor-uploaded-cv'">
                  <button class="ok" @click="uploadMyCvDession(not, 'granted')">
                    Grant
                  </button>
                  <button class="no" @click="uploadMyCvDession(not, 'declined')">
                    Decline
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company_contract_student'">
                  <a class="btn-download ok" :href="$fullUrl('files/certificates/' + not.extra)" target="_blank"
                    download="true">Download</a>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'applied_students'">
                  <button class="ok" @click="viewIntershipBeingApplied(not)">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Close
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'student_internship_confimed'">
                  <button class="no" @click="declineNotification(not.id)">
                    Ok
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'internship_assign'">
                  <button class="ok" @click="() => {
                    $router.push({
                      name: 'view_internship_notification',
                      params: {
                        not_id: not.id,
                        user_id: not.issuer.id,
                        ref_id: not.reference,
                        copy_id: not.extra ? not.extra : 0,
                      },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'student_profile_completion'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'student_survey' ||
                  not.type === 'student_evaluation'
                  ">
                  <button class="ok" @click="() => {
                    $router.push({
                      name: 'view_survey',
                      params: {
                        not_id: not.id,
                        user_id: not.issuer.id,
                        ref_id: not.reference,
                        copy_id: not.extra ? not.extra : 0,
                      },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company-pitching'">
                  <button class="ok" @click="() => {
                    $router.push({
                      name: 'company-details-pitching',
                      params: {
                        not_id: not.id,
                        id: not.reference,
                        manager_id: not.issuer.id,
                      },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'confirm-project-verification' ||
                  not.type === 'confirm-employment-verification'
                  ">
                  <button class="ok" @click="() => {
                    $router.push({ name: 'consultant-profile' });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'student_instructor_remainder'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company-add-member'">
                  <button class="ok" @click="accept(not)">Accept</button>
                  <button class="no" @click="declineNotification(not.id)">
                    Reject
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'accept-assignment'">
                  <button class="ok" @click="() => {
                    $router.push({
                      name: 'assignment-notification-view',
                      params: {
                        not_id: not.id,
                        id: not.reference,
                        manager_id: not.issuer.id,
                      },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'assignment-accepted'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'assignment-not-accepted'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company-add-member-accepted'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'company-add-member-rejected'">
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'invite-manager'">
                  <button class="ok" @click="viewinviteManagerNotification(not)">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else-if="not.type === 'request-merge'">
                  <button class="ok" @click="() => {
                    $router.push({
                      name: 'profile-merge-notification-view',
                      params: { id: not.reference, not_id: not.id },
                    });
                  }
                    ">
                    View
                  </button>
                  <button class="no" @click="declineNotification(not.id)">
                    Dismiss
                  </button>
                </div>

                <div class="options" v-else>
                  <app-dialog v-if="not.type === 'project'" title="Project Invitation"
                    ask="Are you sure you want to accept this project invitation?" yesText="Accept" noText="Cancel"
                    yesBtnClass="btn-default" @onComfirm="viewDirect(not.id)">
                    <button class="ok">Accept</button>
                  </app-dialog>

                  <app-dialog v-if="not.type === 'employment'" title="Employment Invitation"
                    ask="Are you sure you want to accept this employment invitation?" yesText="Accept" noText="Cancel"
                    yesBtnClass="btn-default" @onComfirm="viewDirect(not.id)">
                    <button class="ok">Accept</button>
                  </app-dialog>
                  <app-dialog v-if="not.type === 'profile-view'" title="Profile View"
                    ask="Are you sure you want to grant permission to view your full profile?" yesText="Accept"
                    noText="Cancel" yesBtnClass="btn-default" @onComfirm="accept(not)">
                    <button class="ok">Accept</button>
                  </app-dialog>

                  <button class="ok" v-if="not.type === 'verification'">
                    Accept
                  </button>

                  <button class="no" @click="declineNotification(not.id)">
                    Reject
                  </button>
                </div>

                <!-- Notification Date -->
                <div class="timelabel">
                  {{ not.created_at | moment("dddd, MMMM Do YYYY") }}
                  at
                  {{ not.created_at | moment("h:mm:ss A") }}
                </div>
              </div>
            </div>
          </div>
          <div class="notification-widget-body" v-if="!loading_notifications && notifications.length == 0">
            <div class="empty-notification">
              No new notifications are available
            </div>
          </div>
          <div class="notification-widget-body" v-if="loading_notifications">
            <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="loading_notifications"
              :is-full-page="false" :can-cancel="false" background-color="transparent" class="loader"></loading>
          </div>
        </div>
      </div>
    </div>
    <!-- Manager Invite Modal -->
    <div class="overlay" v-if="show_invite_manager_modal">
      <div class="invite-manager-modal">
        <div class="header">
          <h1>Manager Invitation</h1>
        </div>
        <div class="body">
          <div class="company-widget">
            <div class="company-header">
              <img v-if="notification_item.issuer.company_profile &&
                notification_item.issuer.company_profile.logo
                " :src="$fullUrl(
    'images/profiles/' +
    notification_item.issuer.company_profile.logo
  )
    " />
              <img v-else src="@/assets/icons/logo_avatar.svg" alt />
              <h3 v-if="notification_item.issuer.company_profile">
                {{ notification_item.issuer.company_profile.name }}
              </h3>
            </div>
            <div class="company-body">
              As Manager, you will access for controlling and administering the
              organization. You will be developing and carrying out management
              process. You will be able to manager consultants profiles, create
              leads, invite other managers, etc.
            </div>
            <div class="company-footer">
              <consultfiedButton class="accept-btn" :loading="notification_loading" @click="
                acceptManagerInvitation(
                  notification_item.id,
                  notification_item.reference
                )
                ">
                Accept
              </consultfiedButton>
              <button class="reject-btn" @click="declineNotification(notification_item.id)">
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Maching Modal  -->
    <widgetModal v-if="show_marching_modal" title="Select Assignment"
      subtitle="Here is a list of LIAs in which you have expressed interest. Please select one Assignment from the following to work on"
      btnlefttext="Submit" btncentertext="Cancel" btnrighttext="" :hiderightbtn="true"
      :leftloading="marching_modal_loading" :rightloading="false" :centerloading="false" :footerhidden="false"
      footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="550px"
      :loading="loading_applied_internship" @onLeftClick="onSubmitInternshipMarching()"
      @onCenterClick="show_marching_modal = false">
      <div class="widget-modal-body-noscoll">
        <ul class="internship-items">
          <li class="internship-item" v-for="(item, index) in internship_data" :key="index" :class="{
            active: internship_marching_form.internship_id == item.id,
          }">
            <div class="content">
              <widgetProfile :title="item.name" :file_name="null" :path="$fullUrl('images/profiles/')" :showContent="true"
                :enableRightMargin="true"></widgetProfile>
            </div>
            <div class="item-option">
              <div class="selected-badge" v-if="internship_marching_form.internship_id == item.id">
                Selected
              </div>
              <button v-else @click="selectInternShip(item)" class="btn-select">
                Select
              </button>
            </div>
          </li>
        </ul>
        <!-- <h3 class="notes-title">Notes</h3>
        <textarea
          rows="4"
          v-model="internship_marching_form.comment"
          placeholder="Add comments here for your manager"
          class="note-textarea"
        ></textarea> -->
      </div>
    </widgetModal>

    <!-- Chat -->
    <div class="floater">
      <chat></chat>
    </div>
  </div>
</template>

<script>
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import Chat from "../components/Chat/Chat";
import { eventBus } from "../main";
import { mapGetters } from "vuex";
export default {
  name: "notifications",
  data() {
    return {
      notifications: [],
      loading_notifications: false,
      show_filter: false,
      notification_item: null,
      show_invite_manager_modal: false,
      notification_loading: false,
      show_marching_modal: false,
      marching_modal_loading: false,
      internship_marching_form: {
        not_id: null,
        id: null,
        internship_id: null,
        comment: "",
      },
      internship_data: [],
      loading_applied_internship: false,
      company_rating_form: {
        notification_id: null,
        rate: 0,
        user_id: null,
        reference: null,
      },
      filter_form: {
        query: "",
        type: "All",
      },
      mark_all_as_read_loading: false,
    };
  },
  components: {
    Chat,
    consultfiedButton,
  },
  mounted() {
    let vm = this;
    vm.$store.dispatch("GET_ME_PROFILE_DATA");
    vm.$store.dispatch("RESET_NOTIFICATION");
    vm.getNotifications();
  },
  sockets: {
    connect: function () { },
    notification: function (payload) {
      if (payload.id === this.getHelper.userId) {
        this.notifications.unshift(payload.data);
      }
    },
  },
  computed: {
    ...mapGetters(["getMeProfile"]),
    userId() {
      return this.getMeProfile.user.id;
    },
    isCustomer() {
      return this.getMeProfile.user.account_type == 2;
    },
    user() {
      let job = "";
      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      return {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        available_from: this.getMeProfile.profile.available_from,
        cover_picture: this.getMeProfile.profile.cover_photo,
        location: this.getMeProfile.profile.address,
        job: job,
      };
    },
    notifications_old() {
      let profile = JSON.parse(JSON.stringify(this.getMeProfile));
      return profile.notifications.map(function (item) {
        eventBus.$set(item, "showOption", false);
        eventBus.$set(item, "loading", false);
        if (item.issuer === null) {
          eventBus.$set(item, "issuer", {});
        }
        return item;
      });
    },
  },
  methods: {
    uploadMyCvDession(not, status) {
      let vm = this;
      not.loading = true;
      vm.company_rating_form.notification_id = not.id;
      vm.company_rating_form.user_id = not.user_id;
      vm.company_rating_form.reference = not.reference;
      vm.$store
        .dispatch("STUDENT_UPLOAD_MY_CV_DECISION", {
          notification_id: not.id,
          user_id: not.user_id,
          reference: not.reference,
          status: status,
        })
        .then((value) => {
          vm.getNotifications();
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Thank you for your feedback",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.log(reason);
        });
    },
    approveToConnectAccountWithSchool(not) {
      let vm = this;
      not.loading = true;
      vm.$store
        .dispatch("APPROVE_TO_CONNECT_ACCOUNT_WITH_SCHOOL", {
          notification_id: not.id,
          user_id: not.user_id,
          reference: not.reference,
        })
        .then((value) => {
          vm.getNotifications();
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "You have successfully connected your account with company",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.log(reason);
        });
    },
    markAllAsRead() {
      let vm = this;
      vm.mark_all_as_read_loading = true;
      vm.$store
        .dispatch("NOTIFICATION_MARK_ALL_AS_READ")
        .then((value) => {
          vm.mark_all_as_read_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "All notifications have been marked as read",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          vm.mark_all_as_read_loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.log(reason);
        });
    },
    searchNotification() {
      let vm = this;
      vm.getNotifications();
    },
    filterNotificationType(type) {
      let vm = this;
      vm.filter_form.type = type;
      vm.show_filter = false;
      vm.getNotifications();
    },
    getNotifications() {
      let vm = this;
      vm.loading_notifications = true;
      vm.$store
        .dispatch("NOTIFICATION_GET_ALL", vm.filter_form)
        .then((responce) => {
          vm.loading_notifications = false;
          vm.notifications = responce.data;
        })
        .catch((responce) => {
          vm.loading_notifications = false;
        });
    },
    rateCompany(not) {
      let vm = this;
      not.loading = true;
      vm.company_rating_form.notification_id = not.id;
      vm.company_rating_form.user_id = not.user_id;
      vm.company_rating_form.reference = not.reference;
      vm.$store
        .dispatch("STUDENT_RATE_COMPANY", vm.company_rating_form)
        .then((value) => {
          vm.getNotifications();
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Thank you for rating",
            type: "success",
            duration: 3000,
          });
        })
        .catch((reason) => {
          not.loading = false;
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
          console.log(reason);
        });
    },
    viewIntershipBeingApplied(not) {
      let vm = this;
      vm.$router.push({
        path:
          "/notification/internships/applied/" + not.reference + "/" + not.id,
      });
    },
    getInternship(id) {
      let vm = this;
      vm.loading_applied_internship = true;
      vm.$store
        .dispatch("STUDENT_GET_APPLIED_INTERNSHIP", { user_id: id })
        .then((responce) => {
          vm.loading_applied_internship = false;
          vm.internship_data = responce.data.map((item, index) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((reason) => {
          vm.loading_applied_internship = false;
          console.log(reason);
        });
    },
    selectInternShip(item) {
      let vm = this;
      vm.internship_marching_form.internship_id = item.id;
    },
    showMatchingForm(not) {
      let vm = this;
      vm.internship_marching_form.not_id = not.id;
      vm.internship_marching_form.id = parseInt(not.extra);
      vm.getInternship(vm.internship_marching_form.id);
      vm.show_marching_modal = true;
    },
    onSubmitInternshipMarching() {
      let vm = this;
      const rules = {
        internship_id: {
          run: (value) => {
            if (value) {
              return false;
            }
            return "Please select internship";
          },
        },
      };
      if (vm.$isFieldsValidated(vm.internship_marching_form, rules)) {
        vm.marching_modal_loading = true;
        vm.$store
          .dispatch("STUDENT_COMFIRM_MATCH", vm.internship_marching_form)
          .then((value) => {
            vm.marching_modal_loading = false;
            vm.show_marching_modal = false;
            let logged_user = vm.$getLoggedUser();
            logged_user.matched = true;
            vm.$localStorage.set(
              "logged_user_data",
              JSON.stringify(logged_user)
            );
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Thank for your feedback",
              type: "success",
              duration: 3000,
            });
            vm.getNotifications();
          })
          .catch((reason) => {
            vm.marching_modal_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong",
              type: "warn",
              duration: 3000,
            });
            console.log(reason);
          });
      }
    },
    viewinviteManagerNotification(not) {
      let vm = this;
      vm.notification_item = not;
      vm.$store
        .dispatch("GET_COMPANY_PROFILE_BASED_ON_MANAGER", { id: not.issuer.id })
        .then((value) => {
          eventBus.$set(vm.notification_item, "company_profile", value.data);
          vm.show_invite_manager_modal = true;
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    viewNotification(id) {
      this.$router.push({ name: "notification-view", params: { id: id } });
    },
    viewDirect(id) {
      this.$router.push({
        name: "notification-view",
        params: { id: id, direct: "direct" },
      });
    },
    declineNotification(id) {
      let vm = this;
      this.$store.dispatch("DECLINE_TOBE_MEMBER", { id: id }).then((value) => {
        this.show_invite_manager_modal = false;
        vm.getNotifications();
      });
    },
    acceptManagerInvitation(not_id, id) {
      let vm = this;
      vm.notification_loading = true;
      vm.$store
        .dispatch("ACCEPT_MANAGER_INVITATION", { id: not_id, company_id: id })
        .then((value) => {
          vm.show_invite_manager_modal = false;
          vm.notification_loading = false;
          vm.$store.dispatch("GET_ME_PROFILE_DATA");
          vm.$store.dispatch("TITLE_BAR_INFO");
          vm.$router.push({ name: "crm" });
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    async accept(notification) {
      let vm = this;
      if (notification.type === "project")
        await this.$store.dispatch("ALLOW_TOBE_MEMBER", {
          project: notification.reference,
          id: notification.id,
        });
      else if (notification.type === "employment")
        await this.$store.dispatch("ALLOW_TOBE_MEMBER", {
          project: notification.reference,
          id: notification.id,
        });
      else if (notification.type === "profile-view") {
        await this.$store.dispatch("GRANT_REQUEST_TO_VIEW_PROFILE", {
          user: notification.issuer.id,
          id: notification.id,
        });
      } else if (notification.type === "verification") {
        await this.$store.dispatch("GRANT_PERMISSION", {
          member: notification,
          id: notification.id,
        });
      } else if (notification.type === "company-add-member") {
        await this.$store.dispatch("GRANT_TO_BE_COMPANY_MEMBER", {
          member: notification,
          id: notification.id,
        });
      }
      vm.getNotifications();
    },
  },
};
</script>

<style scoped lang="scss">
$assets: "~@/assets";

.page-wrapper {
  background: #efefef;
  min-height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 55px;
  left: 0px;
  right: 0px;
  bottom: 0px;

  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 45px;
  }

  .page-wrapper-container {
    height: 100%;
    width: 800px;
    display: flex;
    flex-direction: column;

    .page-wrapper-header {
      padding: 10px 0px;

      .options {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .h-spacer {
          width: 10px;
        }

        .dropdown-filter {
          position: relative;
        }
      }
    }

    .page-wrapper-body {
      height: calc(100% - 150px);
      display: flex;
      justify-content: space-between;

      .left-panel {
        width: 200px;
        height: 100%;
        border-radius: 5px;

        .profile-widget {
          background: #fff;
          display: flex;
          align-items: center;
          flex-direction: column;
          padding: 24px 10px;
          border-radius: 5px;

          .profile-name {
            color: #0884af;
          }

          .profile-location {
            text-align: center;
            color: #b4b4b4;
          }
        }
      }

      .right-panel {
        width: calc(100% - 210px);
        height: 100%;

        .notification-widget-body {
          height: 100%;
          overflow-y: auto;
          position: relative;

          .notification-item {
            padding: 15px 20px;
            display: flex;
            background: #fff;
            border-radius: 5px;
            margin-bottom: 10px;

            .profile-widget {
              width: 50px;
            }

            .notification-contents {
              width: calc(100% - 50px);

              h2 {
                font-size: 16px;
                color: rgb(136, 136, 136);
              }

              p {
                margin-bottom: 4px;
                font-size: 13px;
              }

              .rating-status {
                margin-top: 10px;
                color: #939393;
                font-size: 12px;
              }

              .options {
                display: flex;

                .ok {
                  width: max-content;
                  padding: 0px 15px;
                  height: 35px;
                  background: #1ba5a5;
                  border-radius: 4px;
                  color: #fff;
                  margin-right: 20px;
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 500;
                  font-size: 13px;
                  line-height: 20px;
                  display: flex;
                  align-items: center;
                  text-align: center;
                }

                .no {
                  color: #1ba5a4;
                  width: max-content;
                  padding: 0px 15px;
                  height: 35px;
                  background: transparent;
                  border-radius: 4px;
                  margin-right: 20px;
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 500;
                  font-size: 13px;
                  line-height: 20px;
                  display: flex;
                  align-items: center;
                  text-align: center;
                }
              }

              .timelabel {
                font-weight: 500;
                font-size: 13px;
                color: #a5acb8;
                margin-top: 8px;
              }
            }
          }

          .empty-notification {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 80px 10px;
          }
        }
      }
    }
  }

  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 99999;
    background: rgba($color: #000000, $alpha: 0.8);
    display: block;
    padding-top: 90px;

    .invite-manager-modal {
      width: 700px;
      background: #f4f4f4;
      margin: 0 auto;
      border-radius: 5px;
      padding: 68px 44px;

      .header {
        padding: 0px;

        h1 {
          margin: 10px 0px;
          color: #188aab;
          font-size: 18px;
        }
      }

      .body {
        .company-widget {
          background: #fff;
          padding: 10px;
          border-radius: 5px;

          .company-header {
            display: flex;
            align-items: center;
            padding: 10px 0px;

            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              object-fit: cover;
              margin-right: 10px;
            }
          }

          .company-footer {
            display: flex;
            align-items: center;
            padding: 10px 0px;

            .accept-btn {
              width: 107px;
              height: 37px;
              background: #1885ad 0% 0% no-repeat padding-box;
              border-radius: 5px;
              color: #fff;
              outline: none;
              margin-right: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .reject-btn {
              width: 107px;
              height: 37px;
              border: 1px solid #1885ad;
              border-radius: 5px;
              color: #1885ad;
              outline: none;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }

  .widget-modal-body-noscoll {
    margin-top: 15px;

    ul.internship-items {
      list-style: none;
      padding-left: 0px;
      margin: 0px;
      max-height: 250px;
      overflow-y: auto;

      @media (min-width: 300px) and (max-width: 630px) {
        padding: 0px 0px;
      }

      .internship-item {
        background: #ffffff;
        border-radius: 5px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-bottom: 1px solid rgb(239, 239, 239);
        padding: 5px 10px;

        @media (min-width: 300px) and (max-width: 630px) {
          padding: 0px 0px;
        }

        &.active {
          background: #1885ad15;
        }

        .content {
          display: flex;
          align-items: center;

          .internship-item-brand {
            margin-right: 10px;

            img {
              height: 50px;
              width: 50px;
            }
          }

          .title-row {}
        }

        .item-option {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          .selected-badge {
            border-radius: 5px;
            padding: 5px 28px;
            color: #000;
          }

          .btn-select {
            background: #0884af;
            border-radius: 5px;
            padding: 5px 28px;
            color: #fff;
          }
        }
      }
    }

    .notes-title {
      margin-top: 20px;
    }

    .note-textarea {
      width: 100%;
      height: 100px;
      border: 1px solid rgb(225, 225, 225);
      border-radius: 5px;
      padding: 10px;
      resize: none;
      outline: none;
    }
  }
}
</style>